import {Survey} from '../../features/company/culture/surveys/types/SurveyTypes';
import {AppConfig} from '../../lib/AppConfig';

export const formatSurveyLink = (survey: Survey): string =>
  `${AppConfig.PLATFORM_BASE_URL}/company/culture-survey?code=${survey.surveyCode}&initLang=${survey.defaultLanguage}`;
